var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      directives: [
        {
          name: "click-outside",
          rawName: "v-click-outside",
          value: _vm.handleOutsideClick,
          expression: "handleOutsideClick",
        },
      ],
      ref: "appointment_form",
      staticClass: "offcanvas offcanvas-right",
      attrs: { id: "appointment_form" },
    },
    [
      _c("button", {
        staticStyle: { display: "none" },
        attrs: { id: "appointment_form_toggle" },
      }),
      _c(
        "div",
        {
          staticClass:
            "offcanvas-header d-flex align-items-center justify-content-between pb-5",
        },
        [
          _c("h4", { staticClass: "font-weight-bold m-0" }, [
            _vm._v(" " + _vm._s(_vm.title) + " "),
          ]),
          _c(
            "a",
            {
              attrs: { href: "#", id: "appointment_form_close" },
              on: {
                click: function ($event) {
                  return _vm.closeOffcanvas("appointment_form")
                },
              },
            },
            [_c("i", { staticClass: "ki ki-close icon-md" })]
          ),
        ]
      ),
      _c(
        "perfect-scrollbar",
        {
          staticClass: "offcanvas-content mr-n5 scroll",
          staticStyle: { "max-height": "85vh", position: "relative" },
        },
        [
          _vm.isRegularAppointmentForm
            ? _c(
                "div",
                { staticClass: "bb-form-group client-select" },
                [
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: !_vm.selectedClient,
                          expression: "!selectedClient",
                        },
                      ],
                    },
                    [
                      _vm.currentUser.isInLawIndustry
                        ? _c("label", [
                            _vm._v(
                              _vm._s(
                                _vm.$t("appointmentForm.subjectInput.label")
                              )
                            ),
                          ])
                        : _c("label", [
                            _vm._v(
                              _vm._s(
                                _vm.$t("appointmentForm.clientInput.label")
                              )
                            ),
                          ]),
                    ]
                  ),
                  !_vm.currentUser.isInLawIndustry
                    ? _c("BBSelect", {
                        attrs: {
                          options: _vm.clientsAsOptions,
                          search: true,
                          placeholder: _vm.$t(
                            "appointmentForm.clientInput.placeholder"
                          ),
                          searchPlaceholder: _vm.$t(
                            "appointmentForm.clientInput.searchPlaceholder"
                          ),
                          noOptionsText: _vm.$t(
                            "appointmentForm.clientInput.noResultsText"
                          ),
                        },
                        scopedSlots: _vm._u(
                          [
                            _vm.selectedClient
                              ? {
                                  key: "toggle",
                                  fn: function ({ removeSelected }) {
                                    return [
                                      _c(
                                        "div",
                                        {
                                          staticClass: "badge-option-container",
                                          on: {
                                            click: function ($event) {
                                              _vm.clientDetailsVisible =
                                                !_vm.clientDetailsVisible
                                            },
                                          },
                                        },
                                        [
                                          _c(
                                            "div",
                                            { staticClass: "badge-option" },
                                            [
                                              _c(
                                                "div",
                                                { staticClass: "bb-badge" },
                                                [
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(
                                                        _vm.selectedClient
                                                          .initials
                                                      ) +
                                                      " "
                                                  ),
                                                ]
                                              ),
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "badge-option-text",
                                                },
                                                [
                                                  _c("span", [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.selectedClient
                                                          .fullName
                                                      )
                                                    ),
                                                  ]),
                                                  _c("small", [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.selectedClient.email
                                                      )
                                                    ),
                                                  ]),
                                                ]
                                              ),
                                            ]
                                          ),
                                          _c("i", {
                                            class: _vm.clientDetailsArrowClass,
                                          }),
                                        ]
                                      ),
                                      _c(
                                        "div",
                                        {
                                          directives: [
                                            {
                                              name: "show",
                                              rawName: "v-show",
                                              value: _vm.clientDetailsVisible,
                                              expression:
                                                "clientDetailsVisible",
                                            },
                                          ],
                                          staticClass:
                                            "selected-client-details",
                                        },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "selected-client-actions",
                                            },
                                            [
                                              _vm.$hasRole(
                                                _vm.acl.roles.owner
                                              ) ||
                                              _vm.$hasPermission(
                                                _vm.acl.permissions
                                                  .manageAccount
                                              )
                                                ? _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "text-success mr-4",
                                                      on: {
                                                        click: function (
                                                          $event
                                                        ) {
                                                          return _vm.editClient(
                                                            _vm.selectedClient
                                                          )
                                                        },
                                                      },
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.$t(
                                                            "appointmentForm.clientInput.editBtn"
                                                          )
                                                        )
                                                      ),
                                                    ]
                                                  )
                                                : _vm._e(),
                                              _c(
                                                "span",
                                                {
                                                  staticClass: "text-danger",
                                                  on: { click: removeSelected },
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.$t(
                                                        "appointmentForm.clientInput.removeBtn"
                                                      )
                                                    )
                                                  ),
                                                ]
                                              ),
                                            ]
                                          ),
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "selected-client-info",
                                            },
                                            [
                                              _c("h5", [
                                                _vm._v(
                                                  " " +
                                                    _vm._s(
                                                      _vm.$t(
                                                        "appointmentForm.clientInput.details.title"
                                                      )
                                                    ) +
                                                    " "
                                                ),
                                              ]),
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "bb-client-profile-info-item",
                                                },
                                                [
                                                  _c("label", [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.$t(
                                                          "appointmentForm.clientInput.details.emailLabel"
                                                        )
                                                      )
                                                    ),
                                                  ]),
                                                  _c("span", [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.selectedClient.email
                                                      )
                                                    ),
                                                  ]),
                                                ]
                                              ),
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "bb-client-profile-info-item",
                                                },
                                                [
                                                  _c("label", [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.$t(
                                                          "appointmentForm.clientInput.details.phoneLabel"
                                                        )
                                                      )
                                                    ),
                                                  ]),
                                                  _c("span", [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.selectedClient.phone
                                                      )
                                                    ),
                                                  ]),
                                                ]
                                              ),
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "bb-client-profile-info-item",
                                                },
                                                [
                                                  _c("label", [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.$t(
                                                          "appointmentForm.clientInput.details.notesLabel"
                                                        )
                                                      )
                                                    ),
                                                  ]),
                                                  _c("span", [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.selectedClient.notes
                                                      )
                                                    ),
                                                  ]),
                                                ]
                                              ),
                                            ]
                                          ),
                                          _c("AppointmentsList", {
                                            attrs: {
                                              client: _vm.selectedClient,
                                              paginationDisabled: true,
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ]
                                  },
                                }
                              : null,
                            {
                              key: "optionItem",
                              fn: function ({ option }) {
                                return [
                                  _c(
                                    "div",
                                    { staticClass: "badge-option-container" },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "badge-option" },
                                        [
                                          _c(
                                            "div",
                                            { staticClass: "bb-badge" },
                                            [
                                              _vm._v(
                                                " " +
                                                  _vm._s(option.initials) +
                                                  " "
                                              ),
                                            ]
                                          ),
                                          _c(
                                            "div",
                                            {
                                              staticClass: "badge-option-text",
                                            },
                                            [
                                              _c("span", [
                                                _vm._v(_vm._s(option.text)),
                                              ]),
                                              _c("small", [
                                                _vm._v(
                                                  _vm._s(option.description)
                                                ),
                                              ]),
                                            ]
                                          ),
                                        ]
                                      ),
                                    ]
                                  ),
                                ]
                              },
                            },
                            {
                              key: "optionsFooter",
                              fn: function () {
                                return [
                                  _vm.$hasRole(_vm.acl.roles.owner) ||
                                  _vm.$hasPermission(
                                    _vm.acl.permissions.manageAccount
                                  )
                                    ? _c(
                                        "div",
                                        { on: { click: _vm.createClient } },
                                        [
                                          _c("i", {
                                            staticClass: "fas fa-plus",
                                          }),
                                          _c("span", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t(
                                                  "appointmentForm.clientInput.createBtn"
                                                )
                                              )
                                            ),
                                          ]),
                                        ]
                                      )
                                    : _vm._e(),
                                ]
                              },
                              proxy: true,
                            },
                          ],
                          null,
                          true
                        ),
                        model: {
                          value: _vm.form.fields.clientId,
                          callback: function ($$v) {
                            _vm.$set(_vm.form.fields, "clientId", $$v)
                          },
                          expression: "form.fields.clientId",
                        },
                      })
                    : _vm._e(),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.form.errors.clientId,
                          expression: "form.errors.clientId",
                        },
                      ],
                      staticClass: "bb-invalid-feedback",
                    },
                    [_vm._v(" " + _vm._s(_vm.form.errors.clientId) + " ")]
                  ),
                ],
                1
              )
            : _vm._e(),
          _vm.isRegularAppointmentForm
            ? _c("div", { staticClass: "mobile-client-select" }, [
                _vm.selectedClient
                  ? _c("div", [
                      _c(
                        "div",
                        {
                          staticClass: "badge-option-container",
                          on: {
                            click: function ($event) {
                              _vm.clientDetailsVisible =
                                !_vm.clientDetailsVisible
                            },
                          },
                        },
                        [
                          _c("div", { staticClass: "badge-option" }, [
                            _c("div", { staticClass: "bb-badge" }, [
                              _vm._v(
                                " " + _vm._s(_vm.selectedClient.initials) + " "
                              ),
                            ]),
                            _c("div", { staticClass: "badge-option-text" }, [
                              _c("span", [
                                _vm._v(_vm._s(_vm.selectedClient.fullName)),
                              ]),
                              _c("small", [
                                _vm._v(_vm._s(_vm.selectedClient.email)),
                              ]),
                            ]),
                          ]),
                          _c("i", { class: _vm.clientDetailsArrowClass }),
                        ]
                      ),
                      _c(
                        "div",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.clientDetailsVisible,
                              expression: "clientDetailsVisible",
                            },
                          ],
                          staticClass: "selected-client-details",
                        },
                        [
                          _c(
                            "div",
                            { staticClass: "selected-client-actions" },
                            [
                              _vm.$hasRole(_vm.acl.roles.owner) ||
                              _vm.$hasPermission(
                                _vm.acl.permissions.manageAccount
                              )
                                ? _c(
                                    "span",
                                    {
                                      staticClass: "text-success mr-4",
                                      on: {
                                        click: function ($event) {
                                          return _vm.editClient(
                                            _vm.selectedClient
                                          )
                                        },
                                      },
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t(
                                            "appointmentForm.clientInput.editBtn"
                                          )
                                        )
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                              _c(
                                "span",
                                {
                                  staticClass: "text-danger",
                                  on: { click: _vm.removeSelectedClient },
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t(
                                        "appointmentForm.clientInput.removeBtn"
                                      )
                                    )
                                  ),
                                ]
                              ),
                            ]
                          ),
                          _c("div", { staticClass: "selected-client-info" }, [
                            _c("h5", [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.$t(
                                      "appointmentForm.clientInput.details.title"
                                    )
                                  ) +
                                  " "
                              ),
                            ]),
                            _c(
                              "div",
                              { staticClass: "bb-client-profile-info-item" },
                              [
                                _c("label", [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t(
                                        "appointmentForm.clientInput.details.emailLabel"
                                      )
                                    )
                                  ),
                                ]),
                                _c("span", [
                                  _vm._v(_vm._s(_vm.selectedClient.email)),
                                ]),
                              ]
                            ),
                            _c(
                              "div",
                              { staticClass: "bb-client-profile-info-item" },
                              [
                                _c("label", [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t(
                                        "appointmentForm.clientInput.details.phoneLabel"
                                      )
                                    )
                                  ),
                                ]),
                                _c("span", [
                                  _vm._v(_vm._s(_vm.selectedClient.phone)),
                                ]),
                              ]
                            ),
                            _c(
                              "div",
                              { staticClass: "bb-client-profile-info-item" },
                              [
                                _c("label", [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t(
                                        "appointmentForm.clientInput.details.notesLabel"
                                      )
                                    )
                                  ),
                                ]),
                                _c("span", [
                                  _vm._v(_vm._s(_vm.selectedClient.notes)),
                                ]),
                              ]
                            ),
                          ]),
                          _c("AppointmentsList", {
                            attrs: {
                              client: _vm.selectedClient,
                              paginationDisabled: true,
                            },
                          }),
                        ],
                        1
                      ),
                    ])
                  : _vm._e(),
                !_vm.selectedClient
                  ? _c(
                      "div",
                      {
                        staticClass: "mobile-client-select-btn",
                        on: { click: _vm.selectClient },
                      },
                      [
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm.$t("appointmentForm.clientInput.placeholder")
                            )
                          ),
                        ]),
                        _c("i", { staticClass: "la la-angle-right" }),
                      ]
                    )
                  : _vm._e(),
              ])
            : _vm._e(),
          _vm.isGroupAppointmentForm
            ? _c("div", [
                _c(
                  "button",
                  {
                    staticClass: "multiple-client-select-btn",
                    attrs: { type: "button" },
                    on: {
                      click: function ($event) {
                        return _vm.selectClients()
                      },
                    },
                  },
                  [
                    _c("span", [_vm._v(_vm._s(_vm.clientsInputBtnLabel))]),
                    _c("i", { staticClass: "la la-angle-right" }),
                  ]
                ),
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.form.errors.clientIds,
                        expression: "form.errors.clientIds",
                      },
                    ],
                    staticClass: "bb-invalid-feedback",
                  },
                  [_vm._v(" " + _vm._s(_vm.form.errors.clientIds) + " ")]
                ),
              ])
            : _vm._e(),
          _c("hr"),
          _c(
            "div",
            {
              staticClass: "bb-date-input-value-container",
              on: { click: _vm.selectDate },
            },
            [
              _c("span", { staticClass: "bb-date-input-value" }, [
                _vm._v(_vm._s(_vm.selectedDateString)),
              ]),
              _c("i", { staticClass: "la la-angle-right" }),
            ]
          ),
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.form.errors.date,
                  expression: "form.errors.date",
                },
              ],
              staticClass: "bb-invalid-feedback",
            },
            [_vm._v(" " + _vm._s(_vm.form.errors.date) + " ")]
          ),
          _c("hr"),
          _c(
            "div",
            { staticClass: "bb-form-group service-select" },
            [
              _c("label", [
                _vm._v(_vm._s(_vm.$t("appointmentForm.serviceInput.label"))),
              ]),
              _c("BBSelect", {
                staticClass: "service-select",
                attrs: {
                  options: _vm.serviceOptions,
                  search: true,
                  placeholder: _vm.$t(
                    "appointmentForm.serviceInput.placeholder"
                  ),
                  searchPlaceholder: _vm.$t(
                    "appointmentForm.serviceInput.searchPlaceholder"
                  ),
                  noOptionsText: _vm.$t(
                    "appointmentForm.serviceInput.noResultsText"
                  ),
                },
                scopedSlots: _vm._u([
                  {
                    key: "optionGroupItem",
                    fn: function ({ option }) {
                      return [
                        _c("div", { staticClass: "service-option-container" }, [
                          _c("div", { staticClass: "service-option-text" }, [
                            _c("span", [_vm._v(_vm._s(option.text))]),
                            _c("small", [_vm._v(_vm._s(option.description))]),
                          ]),
                          _c("span", [_vm._v(_vm._s(option.price))]),
                        ]),
                      ]
                    },
                  },
                  {
                    key: "optionsFooter",
                    fn: function () {
                      return [
                        _vm.$hasRole(_vm.acl.roles.owner) ||
                        _vm.$hasPermission(_vm.acl.permissions.manageAccount)
                          ? _c(
                              "div",
                              {
                                on: {
                                  click: function ($event) {
                                    return _vm.createService({
                                      placeId: _vm.currentPlace.id,
                                    })
                                  },
                                },
                              },
                              [
                                _c("i", { staticClass: "fas fa-plus" }),
                                _c("span", [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t(
                                        "appointmentForm.serviceInput.createBtn"
                                      )
                                    )
                                  ),
                                ]),
                              ]
                            )
                          : _vm._e(),
                      ]
                    },
                    proxy: true,
                  },
                ]),
                model: {
                  value: _vm.form.fields.serviceId,
                  callback: function ($$v) {
                    _vm.$set(_vm.form.fields, "serviceId", $$v)
                  },
                  expression: "form.fields.serviceId",
                },
              }),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.form.errors.serviceId,
                      expression: "form.errors.serviceId",
                    },
                  ],
                  staticClass: "bb-invalid-feedback",
                },
                [_vm._v(" " + _vm._s(_vm.form.errors.serviceId) + " ")]
              ),
            ],
            1
          ),
          _c("div", { staticClass: "mobile-service-select" }, [
            _c("div", { staticClass: "bb-form-group" }, [
              _c("label", [
                _vm._v(_vm._s(_vm.$t("appointmentForm.serviceInput.label"))),
              ]),
              _c(
                "div",
                {
                  staticClass: "mobile-service-select-btn",
                  on: { click: _vm.selectService },
                },
                [
                  !_vm.selectedService
                    ? _c(
                        "span",
                        { staticClass: "mobile-service-placeholder" },
                        [
                          _vm._v(
                            _vm._s(
                              _vm.$t("appointmentForm.serviceInput.placeholder")
                            )
                          ),
                        ]
                      )
                    : _vm._e(),
                  _vm.selectedService
                    ? _c("span", { staticClass: "mobile-service-selected" }, [
                        _vm._v(_vm._s(_vm.selectedService.name)),
                      ])
                    : _vm._e(),
                  _c("i", { staticClass: "la la-angle-right" }),
                ]
              ),
            ]),
          ]),
          _c(
            "div",
            { staticClass: "bb-form-group" },
            [
              _c("label", [
                _vm._v(_vm._s(_vm.$t("appointmentForm.staffInput.label"))),
              ]),
              _c("BBSelect", {
                attrs: {
                  options: _vm.staffOptions,
                  placeholder: _vm.$t("appointmentForm.staffInput.placeholder"),
                  search: true,
                  searchPlaceholder: _vm.$t(
                    "appointmentForm.staffInput.searchPlaceholder"
                  ),
                  noOptionsText: _vm.$t(
                    "appointmentForm.staffInput.noResultsText"
                  ),
                },
                scopedSlots: _vm._u([
                  {
                    key: "optionItem",
                    fn: function ({ option }) {
                      return [
                        _c("div", { staticClass: "badge-option-container" }, [
                          _c("div", { staticClass: "badge-option" }, [
                            _c(
                              "div",
                              {
                                staticClass: "bb-badge",
                                staticStyle: { flex: "0 0 auto" },
                                style: "background-color:" + option.color,
                              },
                              [_vm._v(" " + _vm._s(option.initials) + " ")]
                            ),
                            _c("div", { staticClass: "badge-option-text" }, [
                              _c("span", [_vm._v(_vm._s(option.text))]),
                              _c("small", [_vm._v(_vm._s(option.description))]),
                            ]),
                          ]),
                        ]),
                      ]
                    },
                  },
                  {
                    key: "optionsFooter",
                    fn: function () {
                      return [
                        _vm.$hasRole(_vm.acl.roles.owner) ||
                        _vm.$hasPermission(_vm.acl.permissions.manageAccount) ||
                        _vm.$hasPermission(_vm.acl.permissions.managePlace)
                          ? _c("div", { on: { click: _vm.createCalendar } }, [
                              _c("i", { staticClass: "fas fa-plus" }),
                              _c("span", [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t(
                                      "appointmentForm.staffInput.createBtn"
                                    )
                                  )
                                ),
                              ]),
                            ])
                          : _vm._e(),
                      ]
                    },
                    proxy: true,
                  },
                ]),
                model: {
                  value: _vm.form.fields.calendarId,
                  callback: function ($$v) {
                    _vm.$set(_vm.form.fields, "calendarId", $$v)
                  },
                  expression: "form.fields.calendarId",
                },
              }),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.form.errors.calendarId,
                      expression: "form.errors.calendarId",
                    },
                  ],
                  staticClass: "bb-invalid-feedback",
                },
                [_vm._v(" " + _vm._s(_vm.form.errors.calendarId) + " ")]
              ),
            ],
            1
          ),
          _c("div", { staticClass: "d-flex justify-content-between pt-5" }, [
            _c(
              "div",
              { staticClass: "bb-form-group mr-2" },
              [
                _c("label", [
                  _vm._v(
                    _vm._s(_vm.$t("appointmentForm.startTimeInput.label"))
                  ),
                ]),
                _c("BBSelect", {
                  attrs: {
                    options: _vm.startTimeOptions,
                    placeholder: _vm.$t(
                      "appointmentForm.startTimeInput.placeholder"
                    ),
                    noOptionsText: _vm.noStartTimeOptionsText,
                  },
                  model: {
                    value: _vm.form.fields.from,
                    callback: function ($$v) {
                      _vm.$set(_vm.form.fields, "from", $$v)
                    },
                    expression: "form.fields.from",
                  },
                }),
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.form.errors.from,
                        expression: "form.errors.from",
                      },
                    ],
                    staticClass: "bb-invalid-feedback",
                  },
                  [_vm._v(" " + _vm._s(_vm.form.errors.from) + " ")]
                ),
              ],
              1
            ),
            _c("div", { staticClass: "bb-form-group ml-2" }, [
              _c("label", [
                _vm._v(_vm._s(_vm.$t("appointmentForm.durationLabel"))),
              ]),
              _c("div", { staticClass: "appointment-duration-value" }, [
                _c("span", {}, [_vm._v(_vm._s(_vm.appointmentDuration))]),
              ]),
            ]),
          ]),
          _c(
            "div",
            { staticClass: "recurrence-section" },
            [
              _c("div", { staticClass: "recurrence-toggle-row" }, [
                _c("label", { staticClass: "recurrence-toggle-label" }, [
                  _c("span", { staticClass: "recurrence-toggle-switch" }, [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.recurrence.isRecurring,
                          expression: "recurrence.isRecurring",
                        },
                      ],
                      attrs: { type: "checkbox" },
                      domProps: {
                        checked: Array.isArray(_vm.recurrence.isRecurring)
                          ? _vm._i(_vm.recurrence.isRecurring, null) > -1
                          : _vm.recurrence.isRecurring,
                      },
                      on: {
                        change: function ($event) {
                          var $$a = _vm.recurrence.isRecurring,
                            $$el = $event.target,
                            $$c = $$el.checked ? true : false
                          if (Array.isArray($$a)) {
                            var $$v = null,
                              $$i = _vm._i($$a, $$v)
                            if ($$el.checked) {
                              $$i < 0 &&
                                _vm.$set(
                                  _vm.recurrence,
                                  "isRecurring",
                                  $$a.concat([$$v])
                                )
                            } else {
                              $$i > -1 &&
                                _vm.$set(
                                  _vm.recurrence,
                                  "isRecurring",
                                  $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                                )
                            }
                          } else {
                            _vm.$set(_vm.recurrence, "isRecurring", $$c)
                          }
                        },
                      },
                    }),
                    _c("span", { staticClass: "toggle-slider" }),
                  ]),
                  _c("span", { staticClass: "recurrence-toggle-text" }, [
                    _vm._v(_vm._s(_vm.$t("appointmentForm.recurrence.toggle"))),
                  ]),
                ]),
              ]),
              _c("transition", { attrs: { name: "recurrence-expand" } }, [
                _vm.recurrence.isRecurring
                  ? _c("div", { staticClass: "recurrence-fields" }, [
                      _c("div", { staticClass: "bb-form-group" }, [
                        _c("label", { staticClass: "recurrence-label" }, [
                          _vm._v(
                            _vm._s(
                              _vm.$t("appointmentForm.recurrence.intervalLabel")
                            )
                          ),
                        ]),
                        _c("div", { staticClass: "recurrence-frequency-row" }, [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model.number",
                                value: _vm.recurrence.repeatInterval,
                                expression: "recurrence.repeatInterval",
                                modifiers: { number: true },
                              },
                            ],
                            staticClass: "bb-input recurrence-interval-input",
                            attrs: { type: "number", min: "1", step: "1" },
                            domProps: { value: _vm.recurrence.repeatInterval },
                            on: {
                              input: [
                                function ($event) {
                                  if ($event.target.composing) return
                                  _vm.$set(
                                    _vm.recurrence,
                                    "repeatInterval",
                                    _vm._n($event.target.value)
                                  )
                                },
                                _vm.onRepeatIntervalInput,
                              ],
                              blur: function ($event) {
                                return _vm.$forceUpdate()
                              },
                            },
                          }),
                          _c("span", { staticClass: "recurrence-unit-label" }, [
                            _vm._v(
                              _vm._s(
                                _vm.$t("appointmentForm.recurrence.units.weeks")
                              )
                            ),
                          ]),
                        ]),
                        _c(
                          "div",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.recurrence.errors.repeatInterval,
                                expression: "recurrence.errors.repeatInterval",
                              },
                            ],
                            staticClass: "bb-invalid-feedback",
                          },
                          [
                            _vm._v(
                              " " +
                                _vm._s(_vm.recurrence.errors.repeatInterval) +
                                " "
                            ),
                          ]
                        ),
                      ]),
                      _c("div", { staticClass: "bb-form-group" }, [
                        _c("label", { staticClass: "recurrence-label" }, [
                          _vm._v(
                            _vm._s(
                              _vm.$t("appointmentForm.recurrence.endDateLabel")
                            )
                          ),
                        ]),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.recurrence.endDate,
                              expression: "recurrence.endDate",
                            },
                          ],
                          staticClass: "bb-input recurrence-date-input",
                          attrs: { type: "date", min: _vm.minEndDate },
                          domProps: { value: _vm.recurrence.endDate },
                          on: {
                            change: function ($event) {
                              _vm.recurrence.errors.endDate = null
                            },
                            input: function ($event) {
                              if ($event.target.composing) return
                              _vm.$set(
                                _vm.recurrence,
                                "endDate",
                                $event.target.value
                              )
                            },
                          },
                        }),
                        _c(
                          "div",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.recurrence.errors.endDate,
                                expression: "recurrence.errors.endDate",
                              },
                            ],
                            staticClass: "bb-invalid-feedback",
                          },
                          [
                            _vm._v(
                              " " + _vm._s(_vm.recurrence.errors.endDate) + " "
                            ),
                          ]
                        ),
                      ]),
                    ])
                  : _vm._e(),
              ]),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "bb-form-group" },
            [
              _c("label", [
                _vm._v(_vm._s(_vm.$t("appointmentForm.notesInput.label"))),
              ]),
              _c("b-form-textarea", {
                staticClass: "bb-textarea",
                attrs: {
                  placeholder: _vm.$t("appointmentForm.notesInput.placeholder"),
                  rows: "4",
                },
                model: {
                  value: _vm.form.fields.notes,
                  callback: function ($$v) {
                    _vm.$set(_vm.form.fields, "notes", $$v)
                  },
                  expression: "form.fields.notes",
                },
              }),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.form.errors.notes,
                      expression: "form.errors.notes",
                    },
                  ],
                  staticClass: "bb-invalid-feedback",
                },
                [_vm._v(" " + _vm._s(_vm.form.errors.notes) + " ")]
              ),
            ],
            1
          ),
        ]
      ),
      _c("div", { staticClass: "offcanvas-footer" }, [
        _c(
          "button",
          {
            staticClass: "bb-btn btn-success",
            on: {
              click: function ($event) {
                return _vm.submit()
              },
            },
          },
          [_vm._v(" " + _vm._s(_vm.submitButtonText) + " ")]
        ),
      ]),
      _c("ServiceFormModal", { ref: "serviceFormModal" }),
      _c("CalendarFormModal", { ref: "calendarFormModal" }),
      _c("ClientFormModal", { ref: "clientFormModal" }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }